import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  readonly msalService = inject(MsalService);

  isAuthenticated(): boolean {
    return !!this.getActiveAccount();
  }

  getActiveAccount(): AccountInfo | null {
    const activeAccount = this.msalService.instance.getActiveAccount();
    if (activeAccount) {
      return activeAccount;
    }

    const [firstAccount] = this.msalService.instance.getAllAccounts();
    if (firstAccount) {
      this.msalService.instance.setActiveAccount(firstAccount);
      return firstAccount;
    }

    return null;
  }

  login(): void {
    this.msalService.loginRedirect();
  }

  getRequiredRoles(route: ActivatedRouteSnapshot): string[] {
    let roles: string[] = [];

    if (route.data?.['roles']) {
      roles = [...roles, ...route.data['roles']];
    }

    let parent = route.parent;
    while (parent) {
      if (parent.data?.['roles']) {
        roles = [...roles, ...parent.data['roles']];
      }
      parent = parent.parent;
    }

    return [...new Set(roles)];
  }

  getRoles(): string[] {
    const account = this.getActiveAccount();
    const claims = account?.idTokenClaims as any;
    return claims?.roles || [];
  }

  hasRequiredRoles(roles: string[]): boolean {
    if (!roles.length) {
      return true;
    }

    const userRoles = this.getRoles();
    return roles.some((role) => userRoles.includes(role));
  }

  checkMenuAccess(roles: string[] = []): boolean {
    return this.hasRequiredRoles(roles);
  }
}
